import _merge from 'lodash/merge';
import _size from 'lodash/size';
import _reduce from 'lodash/reduce';
import _unset from 'lodash/unset';
import EventBus from '@/event-bus';
import _regToolsInstance from '@/tools/reg-tools';
import Shop from '@/shop';
import _Singleton, { deferredSingletonExport } from '@/tools/singleton';
import urlTool from '@/tools/url';

const _regTools = new _regToolsInstance();

/**
 * Живой поиск по сайту
 *
 * @class
 *
 * @fires before:insales:search
 * @fires update:insales:search
 * @fires always:insales:search
 */
var Search = function () {
  var self = this;

  // настройки по-умолчанию
  self._default = {
    settings: {
      searchSelector: 'data-search-field',
      resultPlaceholder: 'data-search-result',
      markerClass: 'ajax_search-marked',
      letters: 3,
      template: 'search-default',
      delay: 500
    }
  };

  //
  self.path = '/search_suggestions';
  self.keyupTimeoutID = '';

  self._init();
};

/**
 * Настройка
 * @private
 * @param  {object} options конфигурация поиска
 */
Search.prototype._init = function () {
  var self = this;

  self.setConfig({});
};

/**
 * Что-то забираем
 * @private
 *
 * @param {Object}
 * @param {string} query - запрос для поиска
 * @param {Object} input - jquery(input)
 */
Search.prototype._get = function (options) {
  var self = this;

  EventBus.publish('before:insales:search');

  clearTimeout(self.keyupTimeoutID);

  if (self._isValid(options.query)) {
    self.data.query = options.query;
    self.keyupTimeoutID = setTimeout(async function () {
      const searchURL = new URL(location.origin + self.path);
      const paramsEntries = Object.entries(self.data);

      paramsEntries.forEach(([ param, val ]) => {
        if (param === 'fields') {
          val.forEach(value => {
            searchURL.searchParams.append('fields[]', value);
          });

          return;
        }

        searchURL.searchParams.append(param, val);
      });

      const response = await fetch(searchURL.href);
      const responseJSON = await response.json();

      self._update(_merge(options, responseJSON));
    }, self.settings.delay);
  }
  else {
    self._update(options);
  }
};

/**
 * Обновление состояния
 * @private
 */
Search.prototype._update = function (options) {
  var self = this;

  var data = {
    suggestions: self._patch(options),
    action: options
  };

  data.invalid = !self._isValid(options.query);
  data.empty = !_size(options.suggestions);
  data.letters = self.settings.letters;

  _unset(data.action, 'suggestions');

  if (data.suggestions.length > 0 && data.action.form) {
    data.action.form.addClass('is-show');
  } else if (data.action.form) {
    data.action.form.removeClass('is-show');
  }

  EventBus.publish('update:insales:search', data);
};

/**
 * Обновляем настройки
 * @param {Object} settings - объект с настройками
 * @param {Object} settings.letters - минимальное кол-во символов для поиска, 3 символа
 * @param {Object} settings.template - шаблон вывода результатов, 'search-default'
 * @param {Object} settings.delay - задержка начала поиска после нажатия, 300 мс
 */
Search.prototype.setConfig = function (settings) {
  var self = this;

  _merge(self, self._default, { settings: settings });

  self._setData(settings.hide_items_out_of_stock);

  self.settings.replacment = '<span class="' + self.settings.markerClass + '">$1</span>';
};

/**
 * Параметры запросов
 *
 * Тащим поля из настроек магазина и текущей локали
 * @private
 */
Search.prototype._setData = function (hide_items_out_of_stock) {
  var self = this;
  var _data = { fields: [ 'price_min', 'price_min_available' ] };

  _merge(_data,
    Shop.config.get([ 'account_id', 'hide_items_out_of_stock', 'locale' ])
  );

  if (typeof hide_items_out_of_stock != 'undefined') {
    _data.hide_items_out_of_stock = hide_items_out_of_stock;
  }

  _merge(self, { data: _data });
};

/**
 * приводим в общий порядок список поиска
 * @private
 */
Search.prototype._patch = function (options) {
  var self = this;
  var _regExp = new RegExp('(' + _regTools.escape(options.query) + ')', 'gi');
  const lang = urlTool.getKeyValue('lang') || '';

  return _reduce(options.suggestions, function (result, product) {
    var temp = {
      id: product.data,
      url: '/product_by_id/' + product.data,
      title: product.value,
      markedTitle: product.value.replace(_regExp, self.settings.replacment)
    };

    if (lang) {
      temp.url += '?lang=' + lang;
    }

    result.push(_merge(product, temp));

    return result;
  }, []);
};

/**
 * Является ли строка поиска достойной для поиска??
 * @private
 */
Search.prototype._isValid = function (query) {
  var self = this;

  return query !== '' && query.length >= self.settings.letters;
};

export default deferredSingletonExport(_Singleton(Search), Search);
